// src/modules/aspirantometro/AspirantometroPage.js
import React, { useState, useEffect } from 'react';
import { db, paths } from '../../firebase/config';
import { collection, onSnapshot } from 'firebase/firestore';
import { AspirantometroCard } from '../../components/AspirantometroCard'; 
import { LoadingSpinner } from '../../components/LoadingSpinner'; 

export const AspirantometroPage = () => {
    const [aspirantometros, setAspirantometros] = useState([]);
    const [loadingAspirantometro, setLoadingAspirantometro] = useState(true);

    useEffect(() => {
        // Escuta em tempo real a coleção 'aspirantometros'
        const unsub = onSnapshot(collection(db, paths.aspirantometros), (snapshot) => {
            const list = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
            
            // CORREÇÃO: Usando localeCompare para ordenar strings YYYY-MM-DD evita bugs de fuso horário do Brasil
            setAspirantometros(list.sort((a, b) => a.data_final.localeCompare(b.data_final)));
            
            setLoadingAspirantometro(false);
        }, (err) => {
            console.error("Erro ao carregar aspirantômetros:", err);
            setLoadingAspirantometro(false);
        });

        return () => unsub();
    }, []);

    return (
        <div className="w-full h-full space-y-6 p-6 bg-white rounded-xl shadow-lg">
            <h1 className="text-3xl font-bold text-gray-800 mb-6 flex items-center">
                ⭐ Aspirantômetro
            </h1>
            
            {loadingAspirantometro ? (
                <div className="text-center py-12">
                    <LoadingSpinner text="Carregando cronômetros..." />
                </div>
            ) : (
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
                    {aspirantometros.map(a => (
                        <AspirantometroCard key={a.id} aspirantometro={a} />
                    ))}
                    {aspirantometros.length === 0 && (
                        <p className="col-span-4 text-center text-gray-500 py-4">
                            Nenhum cronômetro ativo no momento.
                        </p>
                    )}
                </div>
            )}
        </div>
    );
};